'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresReservationExtraServicesCardController = function () {
    function WinresReservationExtraServicesCardController($filter) {
        _classCallCheck(this, WinresReservationExtraServicesCardController);

        this.$filter = $filter;
    }

    _createClass(WinresReservationExtraServicesCardController, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'getPriceLabel',
        value: function getPriceLabel(price) {
            return price.Label + " " + this.getPriceEur(price);
        }
    }, {
        key: 'getPriceEur',
        value: function getPriceEur(price) {
            // const decimalPlaces = _.isInteger(price.Price) ? 0 : 2;
            var decimalPlaces = 2;
            return this.$filter('currency')(price.Price, '€', decimalPlaces);
        }
    }]);

    return WinresReservationExtraServicesCardController;
}();

WinresReservationExtraServicesCardController.$inject = ['$filter'];

_module3.default.component('winresReservationExtraServicesCard', {
    template: require('./winresReservationExtraServicesCard.html'),
    controller: WinresReservationExtraServicesCardController,
    bindings: {
        item: '<',
        group: '<',
        addItem: '&',
        updateGroupBookingItem: '&'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationExtraServicesCard/winresReservationExtraServicesCard.js
// module id = 493
// module chunks = 2